import {derived, writable} from 'svelte/store'
import { path, pattern } from 'svelte-pathfinder';
import {user} from "./user";

export const routes = [
    {
        pattern: '/login',
        requires_sign_in: false,
        show_when_signed_in: false,
        appears_in_menu: true,
        appears_in_debug_menu: false,
        name: 'login',
        display_name: 'Login',
    },
    {
        pattern: '/signin',  // NB one of the auth paths for handling shit
        requires_sign_in: false,
        show_when_signed_in: false,
        appears_in_menu: false,
        appears_in_debug_menu: false,
        name: 'signin',
        display_name: 'Sign In',
    },
    {
        pattern: '/register',
        requires_sign_in: false,
        show_when_signed_in: false,
        appears_in_menu: true,
        appears_in_debug_menu: false,
        name: 'register',
        display_name: 'Sign Up',
    },
    {
        pattern: '/welcome',
        requires_sign_in: true,
        show_when_signed_in: true,
        appears_in_menu: false,
        appears_in_debug_menu: false,
        name: 'welcome',
        display_name: 'Welcome',
    },
    {
        pattern: '/',
        requires_sign_in: true,
        show_when_signed_in: true,
        appears_in_menu: true,
        appears_in_debug_menu: false,
        name: 'home',
        display_name: 'Home',
    },
];


let $path = null;
const path_unsubscribe = path.subscribe(val => $path = val);

export const current_page = derived(pattern, $pattern => {
    console.log('reassessing current page', $path)
    let matched_page = routes.find(route => $pattern(route.pattern)) || null;
    console.log(matched_page);
    return matched_page;
});


export const router = writable({
    current_page: 'discovery',
    navigation_data: null,
    navigate_to_next: null
});

let $router = null;
const unsubscribe = router.subscribe(val => $router = val);

/*

const _internalRedirect = (page, page_navigate_to_next, data = null) => {
    router.set({
        current_page: page,
        navigation_data: data,
        navigate_to_next: page_navigate_to_next
    });
};
const _httpRedirect = (url) => {
    window.location.href = url;
};

export const navigateTo = (user, page, data) => {
    if(data === undefined) data = null;

    // If a page requires a user to be logged in, but the user isn't, then redirect to the login screen
    if(AVAILABLE_PAGES[page].requires_sign_in && !user.signed_in) {

        _internalRedirect('login', page, data);
        // router.set({
        //     current_page: 'login',
        //     navigation_data: data,
        //     navigate_to_next: page
        // });
        return;
    }

    _internalRedirect(page, null, data);
    // router.set({
    //     current_page: page,
    //     navigation_data: data,
    //     navigate_to_next: null
    // });
};

export const doRedirect = (user, data) => {
    console.log('Redirecting')
    if($router.navigate_to_next !== null) {
        navigateTo(user, $router.navigate_to_next, data);
        console.log(`to ${$router.navigate_to_next}`)
    }
    else {
        console.log('defaulting to discovery')
        navigateTo(user,'discovery');
    }
};
*/